import gql from 'graphql-tag';

/**
 * 程序启动（热启动）上报
 */
export const fetchUserClickBuriedPointDocument = gql`
  mutation userClick {
    userClick
  }
`;

/**
 * 商品点击上报
 */
export const fetchUserClickProductBuriedPointDocument = gql`
  mutation userClickProduct($productId: ID) {
    userClickProduct(productId: $productId)
  }
`;

/**
 * 用户设备信息上报
 */
export const fetchUserDeviceDocument = gql`
  mutation userDevice($openIdKey: String!, $deviceInfo: JSON) {
    userDevice(openIdKey: $openIdKey, deviceInfo: $deviceInfo) {
      errorCode
      message
    }
  }
`;

/**
 * 分销信息上报
 */
export const fetchReportedDistributorRecordDocument = gql`
  mutation reportedDistributorRecord(
    $md5Str: String
    $sourceCode: String
    $distributionId: String
  ) {
    reportedDistributorRecord(
      md5Str: $md5Str
      sourceCode: $sourceCode
      distributionId: $distributionId
    )
  }
`;

/**
 * 来源信息上报
 */
export const fetchAddCustomerSourceDocument = gql`
  mutation addCustomerSource($customerSourceInput: CustomerSourceInput!) {
    addCustomerSource(customerSourceInput: $customerSourceInput) {
      id
    }
  }
`;

/**
 * 小程序来源信息上报
 */
export const fetchAddCustomerSourceMiniProgramDocument = gql`
  mutation addCustomerSourceMiniProgram($customerReferralInput: CustomerReferralSourceInput!) {
    addCustomerSourceMiniProgram(customerReferralInput: $customerReferralInput) {
      id
    }
  }
`;
